var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-modal',{attrs:{"active":_vm.isActive,"content-class":"tw-h-1/2 tw-w-1/2"},on:{"update:active":function($event){_vm.isActive=$event}}},[_c('PortfolioCreator',{on:{"submit":_vm.forwardSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }